<div id="main-wrapper" class="show">
    <app-header></app-header>
    <app-sidemenu></app-sidemenu>
    <div class="content-body" style="min-height: 1113px; background: #f7f7f7;">
        <div class="container-fluid">
            <router-outlet></router-outlet>
        </div>
    </div>

</div>